import { h, Host } from "@stencil/core";
/** @internal */
export class Popper {
  render() {
    return h(Host, null);
  }
  static get is() { return "es-popper-inner"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["es-popper-inner.css"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["es-popper-inner.css"]
    };
  }
}
//# sourceMappingURL=es-popper-inner.js.map
